<div class="table__row" role="row" *ngFor="let pref of pref;">
        <div class="table" role="grid">
            <div class="table__row table__row--align-middle" role="row">
                <span>{{ pref?.rentalCategory.name }}</span>
            </div>
            <div class="table__row table__row--header" role="row">
                <span  role="columnheader">Type</span>
                <span role="columnheader">Requirements</span>
                <span role="columnheader">Exclusions</span>
            </div>
            <div role="row" *ngFor="let type of pref?.preferenceInstrumentTypes">
                <div class="table" role="grid">
                    <div role="row" *ngFor="let combo of type.preferenceInstrumentCombos">
                        <span role="cell">{{ type.rentalCategory.name }}</span>
                        <span role="cell">{{ combo.type == 0 ? combo.brand.name + ', ' + (combo.size == null ? 'Any' : combo.size)  + ', ' + (combo.color == null ? 'Any' : combo.color)  : '' }}</span>
                        <span role="cell">{{ combo.type == 1 ? combo.brand.name + ', ' + (combo.size == null ? 'Any' : combo.size) + ', ' + (combo.color == null ? 'Any' : combo.color)  : '' }}</span>
                    </div>
                </div>
            </div>
        </div>
</div>
